module.exports = __webpack_public_path__ + "img/slr.00b07d3b.svg";